import { useQuery } from "@tanstack/react-query";
import { bordaService } from "../services/bordaService";

export const useBordas = () => {
  return useQuery({
    queryKey: ["bordas"],
    queryFn: () => bordaService.getBordas(),
  });
};
